import { render, staticRenderFns } from "./validationMFA.vue?vue&type=template&id=605271ac&scoped=true&"
import script from "./validationMFA.vue?vue&type=script&lang=js&"
export * from "./validationMFA.vue?vue&type=script&lang=js&"
import style0 from "./validationMFA.vue?vue&type=style&index=0&id=605271ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605271ac",
  null
  
)

export default component.exports